import PropTypes from 'prop-types';

import CrmAddressCard from '#/modules/crmMgmt/components/CrmAddressCard';
import LinkedCustomerOrderInfoCard from '#/modules/crmMgmt/salesOrder/components/LinkedCustomerOrderInfoCard';
import SalesOrderLinesReadonlySection from '#/modules/crmMgmt/salesOrder/components/SalesOrderLinesReadonlySection';
import SalesOrderMainInfoCard from '#/modules/crmMgmt/salesOrder/components/SalesOrderMainInfoCard';
import { mapSalesOrderShippingAddress } from '#/modules/crmMgmt/salesOrder/helper/mapSalesOrderMeta';
import CreateEditReferenceSection from '#/modules/infra/layout/CreateEditReferenceSection';

/** 銷貨單編輯／配置庫存頁右欄：GET detail 唯讀四區（靜態，儲存 refetch 才更新）。 */
const SalesOrderEditReferenceSections = ({ detail }) => {
  if (!detail) {
    return null;
  }

  return (
    <>
      {detail.customerOrderId ? (
        <CreateEditReferenceSection title="來源客戶訂單">
          <LinkedCustomerOrderInfoCard
            customerOrderId={detail.customerOrderId}
            compact
            nested
          />
        </CreateEditReferenceSection>
      ) : null}
      <CreateEditReferenceSection title="單據快照（唯讀）">
        <SalesOrderMainInfoCard detail={detail} compact nested />
      </CreateEditReferenceSection>
      <CreateEditReferenceSection title="客戶地址">
        <CrmAddressCard
          title="收貨地址"
          address={mapSalesOrderShippingAddress(detail)}
          nested
        />
      </CreateEditReferenceSection>
      <CreateEditReferenceSection title="銷貨明細">
        <SalesOrderLinesReadonlySection
          lines={detail?.lines ?? []}
          manualLines={detail?.manualLines ?? []}
          embedded
          layout="reference"
        />
      </CreateEditReferenceSection>
    </>
  );
};

SalesOrderEditReferenceSections.propTypes = {
  detail: PropTypes.object,
};

export default SalesOrderEditReferenceSections;
